import { MediaErrorType } from './classifyMediaError';

export const GENERIC_ERROR_TRANSLATION_ID = 'zoom.error.generic';

/**
 * Shared error-type -> translation-id lookup, used by both ZoomConnectingScreen
 * (post-handoff, Zoom SDK failures) and the pre-flight device check (RoomNameScreen)
 * so the two surfaces can't drift into inconsistent wording for the same error.
 */
const MEDIA_ERROR_TRANSLATION_ID: Record<MediaErrorType, string> = {
  permissionDenied: 'zoom.error.permission_blocked',
  deviceNotFound: 'zoom.error.device_not_found',
  deviceNotReadable: 'zoom.error.device_in_use',
  deviceOverconstrained: 'zoom.error.device_constraints',
  aborted: GENERIC_ERROR_TRANSLATION_ID,
  insecureContext: 'zoom.error.insecure_context',
};

/**
 * `device` is optional and only changes anything for `permissionDenied`: Zoom's
 * own post-handoff SDK failure doesn't tell us which device was denied (so
 * ZoomConnectingScreen calls this with no device, getting the combined/generic
 * wording), while the pre-flight check (RoomNameScreen) DOES know — camera and
 * mic are probed independently there — so it passes the specific device to get
 * "Camera access is blocked" / "Microphone access is blocked" instead of the
 * combined "Camera and microphone access is blocked".
 */
export function getMediaErrorTranslationId(errorType: string, device?: 'camera' | 'microphone'): string {
  if (errorType === 'permissionDenied' && device === 'camera') return 'zoom.error.permission_blocked_camera';
  if (errorType === 'permissionDenied' && device === 'microphone') return 'zoom.error.permission_blocked_mic';
  return MEDIA_ERROR_TRANSLATION_ID[errorType as MediaErrorType] ?? GENERIC_ERROR_TRANSLATION_ID;
}
